export default __webpack_public_path__ + "static/media/orders-inactive.de6b3774.svg";